import { useQuery } from '@tanstack/react-query'

import { CreditCardAlternativeProductsCategory } from '@appTypes/EligibilityApi.interface'

import { handleApiResponse } from './utils/handleApiResponse'

interface Options<TSelectResult> {
    initialData?: CreditCardAlternativeProductsCategory[]
    select?: (
        cardsResponse: CreditCardAlternativeProductsCategory[]
    ) => TSelectResult
}

export const useUnscoredAlternativeProductsQuery = <TSelectResult>({
    initialData,
    select,
}: Options<TSelectResult>) => {
    return useQuery(
        ['unscoredAlternativeProducts'],
        () =>
            fetch(
                `${process.env.NEXT_PUBLIC_BASE_PATH}/api/unscored-alternative-products/`
            ).then(handleApiResponse),
        {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            retry: 3,
            initialData,
            select,
        }
    )
}
